import React from 'react';
import { Card } from 'primereact/card';
import { ModernButton } from '../../components/ui/ModernButton';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export const DeactivatedPage: React.FC = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/agent/login');
    } catch (error) {
      console.error('Error signing out:', error);
      // Fallback to direct navigation
      navigate('/agent/login');
    }
  };

  return (
    <div className="deactivated-page">
      <div className="deactivated-container">
        <Card className="deactivated-card">
          <div className="deactivated-content">
            <div className="deactivated-icon">
              <i className="pi pi-ban" style={{ fontSize: '4rem', color: '#e74c3c' }}></i>
            </div>
            <h2>Account Deactivated</h2>
            <p>
              Your agent account has been deactivated, so you no longer have
              access to the agent portal.
            </p>
            <p>
              Please contact your administrator to have your account reactivated.
            </p>
            <div className="deactivated-actions">
              <ModernButton
                variant="outline"
                icon="pi pi-sign-out"
                onClick={handleSignOut}
              >
                Sign Out
              </ModernButton>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

// Add some basic styling
const styles = `
.deactivated-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem;
}

.deactivated-card {
  max-width: 500px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  border: none;
}

.deactivated-content {
  text-align: center;
  padding: 2rem;
}

.deactivated-icon {
  margin-bottom: 2rem;
}

.deactivated-content h2 {
  color: #2c3e50;
  margin-bottom: 1rem;
  font-size: 1.8rem;
}

.deactivated-content p {
  color: #7f8c8d;
  margin-bottom: 1rem;
  line-height: 1.6;
}

.deactivated-actions {
  margin-top: 2rem;
}
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}
